module.exports = __webpack_public_path__ + "1touch.8493766099a0eef29b5e.woff";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/1touch.woff
// module id = ../../../../../src/fonts/1touch.woff
// module chunks = 3